import { AGENTS } from "@/lib/agents";
import { motion } from "framer-motion";

export default function AgentsGrid() {
  return (
    <div>
      <div className="mb-6">
        <p className="overline text-emerald-400 mb-1">Equipe da agência</p>
        <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">Seus 7 agentes especializados</h2>
        <p className="text-sm text-slate-400 mt-2 max-w-2xl">
          O Orquestrador coordena. O Analista mede. O Marketing cria a estratégia. O Copywriter comunica.
          O Social Media adapta. O Diretor Criativo gera ideias. O Especialista em Postagens finaliza.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {AGENTS.map((a, i) => {
          const Icon = a.icon;
          return (
            <motion.div
              key={a.id}
              data-testid={`agent-card-${a.id}`}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.06 }}
              className="glass rounded-2xl p-5 hover:brightness-110 transition-all duration-200 group"
              style={{ borderColor: a.color + "33" }}
            >
              <div className="flex items-start justify-between">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center group-hover:scale-105 transition-transform"
                  style={{ backgroundColor: a.color + "22", border: `1px solid ${a.color}55` }}>
                  <Icon className="w-6 h-6" style={{ color: a.color }} />
                </div>
                <span className={`text-[10px] px-2 py-1 rounded-full border ${a.badge} overline`}>Ativo</span>
              </div>
              <h3 className="font-display font-semibold text-lg mt-4 leading-tight">{a.nome}</h3>
              <p className="font-mono text-xs mt-1" style={{ color: a.color }}>{a.cargo}</p>
              <p className="text-sm text-slate-400 mt-3 leading-relaxed">{a.desc}</p>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
